// Config panel for the "dial_external" action block
// Dials an external phone number via the 3CX SIP trunk
import React from 'react';
import {
  Box,
  TextField,
  Typography,
  Alert,
} from '@mui/material';

const DialExternalConfig = ({ config, onChange, onSummaryChange }) => {
  const handleChange = (field, value) => {
    const updated = { ...config, [field]: value };
    onChange(updated);
    const num = updated.phoneNumber || '?';
    const tmo = updated.timeout || 60;
    onSummaryChange(`Dial ${num} (${tmo}s)`);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="caption" color="text.secondary">
        Dial an external phone number through the 3CX SIP trunk.
        The call is routed from Asterisk to 3CX, which dials the external number.
      </Typography>

      <TextField
        size="small"
        label="Phone Number"
        value={config.phoneNumber || ''}
        onChange={(e) => handleChange('phoneNumber', e.target.value)}
        required
        placeholder="+32412345678"
        helperText="E.164 format recommended (e.g. +32412345678). Supports variables: {{variable}}"
      />

      <TextField
        size="small"
        label="Timeout"
        type="number"
        value={config.timeout ?? 60}
        onChange={(e) => handleChange('timeout', Math.min(120, Math.max(10, parseInt(e.target.value) || 60)))}
        inputProps={{ min: 10, max: 120 }}
        sx={{ width: 120 }}
        helperText="seconds (10-120)"
      />

      <TextField
        size="small"
        label="Caller ID Override (optional)"
        value={config.callerId || ''}
        onChange={(e) => handleChange('callerId', e.target.value)}
        placeholder="+32412340000"
        helperText="Leave empty to use the original caller ID"
      />

      <Alert severity="info" variant="outlined" sx={{ py: 0.5, '& .MuiAlert-message': { fontSize: '0.7rem' } }}>
        Requires a configured 3CX SIP trunk (environment variables: TRUNK_3CX_IP,
        TRUNK_3CX_USERNAME, TRUNK_3CX_PASSWORD). Calls are billed by your trunk provider.
      </Alert>
    </Box>
  );
};

export default DialExternalConfig;
